import { css } from '@emotion/react';
import { Modal, notification } from 'antd';
import Router from 'next/router';
import React from 'react';

import Button from '@/src/shared/components/Button';
import formatPayload from '@/src/updateProfile/utils';
import request from '@/utils/axios';

const { confirm } = Modal;

const styles = {
  buttonStyle: css``,
};

function SubmitButton(props) {
  const { form, updateProfile, roles, fieldInfo } = props;
  const { OriginalData } = updateProfile;

  const prefixObject = fieldInfo?.aboutMe?.prefix?.options || {};

  const isEmployee = roles.includes('PCI.Everyone');
  const touched = form.isFieldsTouched();

  const showFormInfo = () => {
    Modal.info({
      title: 'Update Profile',
      content: (
        <div>
          The demographic changes you requested will be reviewed by an administrator before they are
          processed. Therefore, if you return to your Profile today, your Profile may not reflect
          the changes that you made.
        </div>
      ),
      onOk() {},
    });
    const confirmationURL = '/account/update-profile/submission-confirmation/';
    Router.push(confirmationURL, confirmationURL);
  };

  const completeSubmission = async () => {
    await form.validateFields(async (err, values) => {
      if (err) throw err;

      const profileData = {
        Prefix: OriginalData.Name.Prefix || '',
        First: OriginalData.Name.First || '',
        Middle: OriginalData.Name.Middle || '',
        Last: OriginalData.Name.Last || '',
        Suffix: OriginalData.Name.Suffix || '',
        Informal: OriginalData.Name.Informal || '',
        Title: OriginalData.Title || '',
        Company: OriginalData.Company || '',
        CountryCode: OriginalData.Office.CountryCode || '',
        StreetAddress1: OriginalData.Office.StreetAddress1 || '',
        StreetAddress2: OriginalData.Office.StreetAddress2 || '',
        City: OriginalData.Office.City || '',
        StateCode: OriginalData.Office.StateCode || '',
        PostalCode: OriginalData.Office.PostalCode || '',
        PoBoxNumber: OriginalData.PoBox.Number || '',
        PoBoxCity: OriginalData.PoBox.City || '',
        PoBoxStateCode: OriginalData.PoBox.StateCode || '',
        PoBoxPostalCode: OriginalData.PoBox.PostalCode || '',
        Number: OriginalData.Phone.Number || '',
        Extension: OriginalData.Phone.Extension || '',
        Mobile: OriginalData.Mobile || '',
        FaxNumber: OriginalData.FaxNumber || '',
        EmailAddress: OriginalData.EmailAddress || '',
        Comments: OriginalData.Comments || '',
      };

      const formData = {
        Prefix: values.Prefix || '',
        First: values.First || '',
        Middle: values.Middle || '',
        Last: values.Last || '',
        Suffix: values.Suffix || '',
        Informal: values.Informal || '',
        Title: values.Title || '',
        Company: values.Company || '',
        CountryCode: values.CountryCode || '',
        StreetAddress1: values.StreetAddress1 || '',
        StreetAddress2: values.StreetAddress2 || '',
        City: values.City || '',
        StateCode: values.StateCode || '',
        PostalCode: values.PostalCode || '',
        PoBoxNumber: values.PoBoxNumber || '',
        PoBoxCity: values.PoBoxCity || '',
        PoBoxStateCode: values.PoBoxStateCode || '',
        PoBoxPostalCode: values.PoBoxPostalCode || '',
        Number: values.Number || '',
        Extension: values.Extension || '',
        Mobile: values.Mobile || '',
        FaxNumber: values.FaxNumber || '',
        EmailAddress: values.EmailAddress || '',
        Comments: values.Comments || '',
      };

      const notChanged = JSON.stringify(profileData) === JSON.stringify(formData);

      if (!touched || notChanged) {
        notification.warning({
          message: 'Not saved',
          description: 'You have not made any changes to your profile.',
        });
        return;
      }

      const formValues = {
        ...updateProfile,
        ...values,
      };

      confirm({
        title: `Are you sure you wish to update this profile?`,
        keyboard: true,
        okText: 'OK',
        cancelText: 'Cancel',
        onOk: async () => {
          const payload = formatPayload(formValues, prefixObject);
          try {
            const response = await request({
              method: 'POST',
              url: 'servicerequest/submitmemberrequest',
              baseURL: process.env.V2_API_ROOT,
              data: payload,
            });

            const { status } = response;
            if (status === 200) {
              notification.success({
                message: 'Success',
                description: 'Profile Update Submitted Successfully',
              });
              showFormInfo();
            }
          } catch (errors) {
            notification.error({
              message: 'Error',
              description: 'There are errors submitting the registration.',
            });
            throw errors;
          }
        },
      });
    });
  };

  return (
    <Button
      disabled={!touched || isEmployee}
      size="small"
      theme={touched && !isEmployee ? 'darkOutlined' : 'disabled'}
      type="submit"
      onClick={completeSubmission}
      css={styles.buttonStyle}
    >
      Submit
    </Button>
  );
}

export default SubmitButton;
